export default Object.freeze({
  PASSWORD_CHANGED: 'Your password has been changed, please log in with your new credentials.'
})